export default "__VITE_ASSET__C7dIKny4__"